import React from 'react';
import cc from 'classcat';

import { Button, Modal } from '../../index';
import ContactForm from '../../forms/ContactForm';
import { useFormModal } from '../../../hooks/useFormModal';

import EmailIcon from '../../../images/icons/email.svg';

import { ButtonType } from '../Button';

import styles from './styles.module.scss';

interface Props {
  overrideEmail?: string;
  text?: string;
  section?: string;
  name?: string;
  className?: string;
  type?: ButtonType;
}

const EmailButton = ({ overrideEmail, text, section, name, type = 'solidOrange', className }: Props) => {
  const { isOpen: enquireModal, openModal, closeModal } = useFormModal(['enquireForm', 'contactForm']);
  const classNames = cc([styles.emailLink, className, 'newStyleButtonOverrideSolid']);
  const classNamesAlt = cc([className, 'newStyleButtonOverrideSolid']);

  if (overrideEmail) {
    return (
      <Button href={`mailto: ${overrideEmail}`} className={classNames} type="link" large>
        {`Email: ${overrideEmail}`}
      </Button>
    );
  }

  return (
    <>
      <Button onClick={openModal} className={classNamesAlt} type={type} large>
        <EmailIcon />
        {text ? text : 'Send us an email'}
      </Button>
      <Modal isOpen={enquireModal} onRequestClose={closeModal} title={name}>
        <ContactForm section={section} title={name} />
      </Modal>
    </>
  );
};

export default EmailButton;
